var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlighteditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91756 12.2404L17.6655 6.85027L18.8449 8.14618L12.7509 15.3536L9.91756 12.2404ZM7.58746 12.6516L12.1228 17.6349C12.2167 17.7279 12.3292 17.7999 12.453 17.8462C12.5768 17.8925 12.709 17.912 12.8409 17.9034C12.9728 17.8948 13.1013 17.8583 13.2181 17.7964C13.3348 17.7344 13.4371 17.6484 13.5181 17.544L20.9695 8.73102C21.1179 8.56791 21.202 8.35635 21.2059 8.13584C21.2098 7.91532 21.1333 7.70091 20.9908 7.53262L18.4778 4.77146C18.3236 4.61374 18.1174 4.51749 17.8975 4.50069C17.6775 4.48388 17.459 4.54767 17.2827 4.68014L7.80905 11.271C7.69748 11.3418 7.60223 11.4356 7.52958 11.546C7.45693 11.6564 7.40853 11.7809 7.38759 11.9114C7.36664 12.0419 7.37363 12.1754 7.40808 12.303C7.44254 12.4306 7.50367 12.5494 7.58746 12.6516ZM2.79395 18.5273L8.4113 19.4996L9.89044 18.1534L6.86155 14.8254L2.79395 18.5273Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighteditor);
export default __webpack_public_path__ + "static/media/highlighteditor.87839e87000acb3db36f2e90ccd3f96b.svg";
export { ForwardRef as ReactComponent };